import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { 
	getRegions, getProvinces, getMunicipalities, getBarangays, getNCRCities
} from "../../redux/psgcdata/psgcDataState";
import PSGCAPIService from '../../services/psgcapiservice';

const RegionProvinceBarangay = ({recordData, mode, form, getRegionList, regions, rules}) => {
	
	const [provinces, setProvinces] = useState([]);
	const [municipalities, setMunicipalities] = useState([]);
	const [barangays, setBarangays] = useState([]);

	const [hideProvice, setHideProvince] = useState(false);
	
	const handleRegionChange = (value) => {
		const selectedRegion = regions.find(region => region.code === value);
		form.setFieldsValue({
			...form.getFieldsValue(), 
			address_region: selectedRegion ? selectedRegion.name : '',
			address_province_code: null, 
			address_municipality_code: null, 
			address_barangay_code: null
		});
		doGetRegionCityProvince(value);				
    };

	const doGetRegionCityProvince = (code) => {		
		if(code === '130000000'){
			setHideProvince(true);
			getNCRCityList(code);					
		}else{
			setHideProvince(false);
			getProvinceList(code);
		}	
	}

	const handleProvinceChange = (value) => {
		const selectedProvince = provinces.find(province => province.value === value);
		form.setFieldsValue({
			...form.getFieldsValue(), 
			address_province: selectedProvince ? selectedProvince.label : '',
			address_municipality_code: null, 
			address_barangay_code: null
		});
		getMunicipalityList(value);
	}

	const handleMunicipalityChange = (value) =>{
		const selectedMunicipality = municipalities.find(municipality => municipality.value === value);
		
		form.setFieldsValue({
			...form.getFieldsValue(), 
			address_municipality: selectedMunicipality ? selectedMunicipality.label : '',
			address_barangay_code: null,
		});
		getBarangayList(value);
	}
	const handleBarangayChange = (value) =>{
		const selectedBarangay = barangays.find(barangay => barangay.value === value);
		form.setFieldsValue({
			...form.getFieldsValue(), 
			address_barangay: selectedBarangay ? selectedBarangay.label : '',
		});
	}

	useEffect(() => {
		getRegionList({});
		//console.log(recordData);
		if(recordData?.address){
			if(recordData.address?.region_code){
				doGetRegionCityProvince(recordData.address?.region_code);							
			}
			if(recordData.address?.province_code){
				getMunicipalityList(recordData.address?.province_code);
			}
			if(recordData.address?.municipality_code){
				getBarangayList(recordData.address?.municipality_code);
			}
		}

	}, [recordData, form, getRegionList]);

	const psgcAPIPath = 'https://psgc.gitlab.io/api/';
	const getPSGCData = async (endpoint, callback) => {
		try {
			const provinceList = await PSGCAPIService.doRequest(
				`${psgcAPIPath}${endpoint}`, 
				"GET"
			);
			// Convert list to { label, value } format for antd Select
			const options = provinceList.map(region => ({
				label: region.name,
				value: region.code
			}));
			callback && callback(options);
		} catch (err) {
			console.error("Failed to fetch PSGC data", err);
		}
	}

	const getNCRCityList = async (regionCode) => {
		setProvinces([]);
		setMunicipalities([]);
		setBarangays([]);
		getPSGCData(`regions/${regionCode}/cities.json`, setMunicipalities);
	};

	const getProvinceList = async (regionCode) => {
		setProvinces([]);
		setMunicipalities([]);
		setBarangays([]);
		if(regionCode){
			getPSGCData(`regions/${regionCode}/provinces.json`, setProvinces);
		}
	};

	const getMunicipalityList = async (provinceCode) => {
		setMunicipalities([]);
		setBarangays([]);
		if(provinceCode){
			getPSGCData(`provinces/${provinceCode}/cities-municipalities.json`, setMunicipalities);
		}
	};

	const getBarangayList = async (municipalityCode) => {
		setBarangays([]);
		if(municipalityCode){
			getPSGCData(`cities-municipalities/${municipalityCode}/barangays.json`, setBarangays);
		}
	};
	
  	return (
		<div className="form-column-4">
			<FormItem name="address_region" hidden>
				<Input type="hidden"/>
			</FormItem>
			<FormItem name="address_province" hidden>
				<Input type="hidden"/>
			</FormItem>
			<FormItem name="address_municipality" hidden>
				<Input type="hidden"/>
			</FormItem>
			<FormItem name="address_barangay" hidden>
				<Input type="hidden"/>
			</FormItem>
			<FormItem 
				name="address_region_code"
				label="Region"
				rules={rules}
			>
				{mode === 'edit' ?
				<Select id="address_region_code"
					key={`regions_${regions.length}`}
					options={regions}
					showSearch
					allowClear={true}
					onChange={handleRegionChange}
				/>					
				: <label className="ps-3 dark:text-white">{recordData?.address?.region}</label>
				}	                
			</FormItem>
			<FormItem hidden={hideProvice}
				name="address_province_code"
				label="Province"	
				rules={rules}			
			>
				{mode === 'edit' ?
				<Select id="address_province_code"     
					key={`provinces_${provinces.length}`}
					options={provinces}
					showSearch
					allowClear={true}
					onChange={handleProvinceChange}
				/>					
				: <label className="ps-3 dark:text-white">{recordData?.address?.province}</label>
				}	                
			</FormItem>
			<FormItem 
				name="address_municipality_code"
				label="Municipality/City"
				rules={rules}
			>
				{mode === 'edit' ?
				<Select id="address_municipality_code"   
					key={`municipalities_${municipalities.length}`}
					options={municipalities}
					showSearch
					allowClear={true}
					onChange={handleMunicipalityChange}
				/>
				: <label className="ps-3 dark:text-white">{recordData?.address?.municipality}</label>
				}	                
			</FormItem>	
			<FormItem 
				name="address_barangay_code"
				label="Barangay"
				rules={rules}
			>
				{mode === 'edit' ?
				<Select id="address_barangay_code"   
					key={`barangays_${barangays.length}`}         		
					options={barangays}
					showSearch
					allowClear={true}
					onChange={handleBarangayChange}
				/>
				: <label className="ps-3 dark:text-white">{recordData?.address?.barangay}</label>
				}	                
			</FormItem>            
        </div>
  );
}

const mapStateToProps = (state) => ({
	regions: state.psgcData.regions?.items,
	provinces: state.psgcData.provinces?.items,
	municipalities: state.psgcData.municipalities?.items,
	barangays: state.psgcData.barangays?.items,
});

const mapDispatchToProps = (dispatch) => ({
	getRegionList: (data) => dispatch(getRegions(data)),
	getProvinceList: (data) => dispatch(getProvinces(data)),
	getMunicipalityList: (data) => dispatch(getMunicipalities(data)),
	getBarangayList: (data) => dispatch(getBarangays(data)),
	getNCRCityList: (data) => dispatch(getNCRCities(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegionProvinceBarangay);